var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-table" },
    [
      _c(
        "ma-modal",
        { ref: "adminGagEditModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("gagSalaries.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "zip_code",
                      col: 2,
                      icon: "house",
                      literal: "gagSalaries.table.zip_code",
                      disabled: ""
                    },
                    model: {
                      value: _vm.salaries.zip_code,
                      callback: function($$v) {
                        _vm.$set(_vm.salaries, "zip_code", $$v)
                      },
                      expression: "salaries.zip_code"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "csp",
                      col: 2,
                      icon: "house",
                      literal: "gagSalaries.table.csp",
                      value: _vm.salaries.csp_literal,
                      disabled: ""
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "salary_hour",
                      col: 2,
                      icon: "house",
                      literal: "gagSalaries.table.salary_hour"
                    },
                    model: {
                      value: _vm.salaries.salary_hour,
                      callback: function($$v) {
                        _vm.$set(_vm.salaries, "salary_hour", $$v)
                      },
                      expression: "salaries.salary_hour"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("p", { staticClass: "mg mg--b-4 mg--t-4 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("gagSalaries.title")))
      ]),
      _c("ma-input-text", {
        attrs: {
          type: "text",
          name: "deptCodeFilter",
          col: 1,
          icon: "house",
          literal: "gagZipCode.table.dept_code",
          value: _vm.deptCodeFilterText
        },
        on: { input: _vm.filterTableByDeptCodeDebounced }
      }),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "bg-blueDark" },
            [
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagSalaries.table.zip_code")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagSalaries.table.csp")))
                ])
              ]),
              _c("th", { staticClass: "no--border" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagSalaries.table.salary_hour")))
                ])
              ]),
              _vm.stateUserIsSuperAdmin
                ? [
                    _c("th", {
                      staticClass: "border-right",
                      attrs: { width: "50px" }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm.hasData
          ? _c(
              "tbody",
              _vm._l(_vm.table, function(row) {
                return _vm.table
                  ? _c(
                      "tr",
                      [
                        _c("td", [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.zip_code))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.csp_literal))
                          ])
                        ]),
                        _c("td", { staticClass: "no--border" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.salary_hour))
                          ])
                        ]),
                        _vm.stateUserIsSuperAdmin
                          ? [
                              _c("td", { staticClass: "text-align--right" }, [
                                _c(
                                  "div",
                                  { staticClass: "grid grid--jc-bottom" },
                                  [
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action",
                                      attrs: {
                                        name: "edit",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleEdit(row)
                                        }
                                      }
                                    }),
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action mg mg--l-2",
                                      attrs: {
                                        name: "trash",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(row)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              }),
              0
            )
          : _vm._e()
      ]),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "grid grid--jc-bottom mg mg--t-4" },
            [
              _c("ma-paginator", {
                staticClass: "mg mg--t-2 mg--b-4",
                attrs: { current: _vm.currentPage, total: _vm.totalPages },
                on: {
                  "page:update": _vm.handlePageUpdate,
                  "page:set": _vm.handlePageSet
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.hasData
        ? _c("ma-empty", {
            attrs: {
              icon: "recherche",
              title: _vm.$t("common.noresults.short"),
              descr: _vm.$t("common.noresults.long")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }